import { SchemaRadioYesOrNo, type SelectFieldOption } from '@/types';

const yesOrNoOptions: SelectFieldOption<string>[] = [
  { label: 'Yes', value: SchemaRadioYesOrNo.Yes },
  { label: 'No', value: SchemaRadioYesOrNo.No },
];

export default yesOrNoOptions;
